import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import store from 'store2';

const module = 'text';

export default class List extends Component {

	static contextTypes = {
		location: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			return <a href={'/'+module+'/'+row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a>;
		};

		this.columnModel = [
			{
				name: 'title',
				title: 'Název',
				field: 'title',
				renderer: rendererLink
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width:80,
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={'/'+module+'/'+val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil position-left"></i>Upravit
						</a>
					);
				}
			}
		];

		const filterSchema = {
			fulltext: { class: SearchInput },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-' + module);
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'title', 'direction': 'asc'};

	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on(module + '.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener(module + '.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm(module, row.t, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		const buttons = <Button href={'/' + module + '/0'} onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nový text
		</Button>;

		return (
			<Datagrid
				ref="datagrid"
				id={module}
				api="text.getList"
				buttons={buttons}
				filters={['fulltext']}
				filter={this.filter}
				saveState={true}
				getRowClassName={null}
				columnModel={this.columnModel}
				defaultFilter={this.defaultFilter}
				forceFilter={this.filterUrl}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Text/List.js